<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();
const platformStore = usePlatformStore();

async function showScannerButton(value: boolean) {
  await settingsStore.set('showScannerButton', value);
}
</script>

<template>
  <SettingsToggle
    v-if="platformStore.isMobile"
    :checked="settingsStore.settings.showScannerButton"
    :label="t('materials.barcode.barcodeScannerSetting')"
    :description="t('materials.barcode.barcodeScannerSettingDescription')"
    @change="showScannerButton"
  />
</template>
